<template>
	<el-dialog v-model="visible" title="图片预览" width="70%" draggable>
		<div style="height: 70vh; overflow: auto">
			<img :src="url" alt="" />
		</div>
		<template #footer> </template>
	</el-dialog>
</template>

<script>
export default {
	name: "preview-img",
	data() {
		return {
			visible: false,
			url: "",
		};
	},
	methods: {
		open(url) {
			this.url = url;
			this.visible = true;
		},
	},
};
</script>

<style scoped>
img {
	width: 100%;
	object-fit: cover;
}
::-webkit-scrollbar {
	width: 5px;
}
::-webkit-scrollbar-thumb {
	background-color: #a7bbdd;
	border-radius: 4px;
}
::-webkit-scrollbar-track {
	background-color: #fff;
}
</style>
